import { CheckCircleTwoTone } from '@ant-design/icons';
import { Button, Card, Col, Row, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import bookkeeping from '../../assets/images/job-fee-card/bookkeeping.png';
import accounting from '../../assets/images/job-fee-card/accounting.png';
import businessanalysis from '../../assets/images/job-fee-card/businessanalysis.png';
import taxservices from '../../assets/images/job-fee-card/taxservices.png';
import payrollmanagement from '../../assets/images/job-fee-card/payrollmanagement.png';
import businessfinancing from '../../assets/images/job-fee-card/business-financing.svg';
import { formatDollars } from '../../helpers/functions';

const { Link } = Typography;
const JobFeeCard = ({ title, value }) => {
  const [expanded, setExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  let updated = value.reduce((acc, curr) => {
    if (acc[curr.rate_type.name + '__' + curr.rate_from + '__' + curr.rate_to + '__' + curr.is_percent]) {
      acc[curr.rate_type.name + '__' + curr.rate_from + '__' + curr.rate_to + '__' + curr.is_percent].push(curr);
    } else {
      acc[curr.rate_type.name + '__' + curr.rate_from + '__' + curr.rate_to + '__' + curr.is_percent] = [curr];
    }
    return acc;
  }, []);
  const cardRef = useRef();
  useEffect(() => {
    if (!expanded) {
      cardRef.current.scrollTop = 0;
    }
  }, [expanded]);
  const images = {
    Accounting: accounting,
    Bookkeeping: bookkeeping,
    'Business Analysis': businessanalysis,
    'Tax Services': taxservices,
    'Payroll Management': payrollmanagement,
    'Business Financing': businessfinancing,
  };
  
    

  useEffect(() => {
     setHasOverflow(cardRef?.current?.scrollHeight > cardRef?.current?.clientHeight ||
    cardRef?.current?.scrollWidth > cardRef?.current?.clientWidth)
  }, [hasOverflow]);

  return (
    <>
      <Col key={title} xs={24} sm={24} md={24} lg={12} xl={8} xxl={8}>
        <div className="job-fee-wrapper jobs-fees">
          <Card>
            <div style={{ textAlign: 'center' }}>
              <img
                src={images[title]}
                alt={title}
                style={{ textAlign: 'center', width: '8rem', height: '8rem' }}
              />
              <h1>{title}</h1>
            </div>

            <div ref={cardRef} className={`ant-card-body xyz ${expanded ? 'expanded' : ''}`}>
              {Object.keys(updated)?.length > 0 &&
                Object.keys(updated)?.map((item, ind) => {
                  return (
                    <>
                      <>
                        <Row key={ind} style={{ width: '100%' }}>
                          <Col
                            span={12}
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                            }}
                          >
                            {updated[item][0]?.is_percent ? (
                              <>
                                <Button type="primary">
                                  {formatDollars(item.split('__')[1])} %
                                </Button>
                              </>
                            ) : (
                              <>
                                {' '}
                                <Button type="primary">
                                  CA$ {formatDollars(item.split('__')[1])}
                                </Button>
                              </>
                            )}
                          </Col>
                          <Col
                            span={12}
                            style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                          >
                            {updated[item][0]?.is_percent ? (
                              <>
                                <Button type="primary">
                                  {formatDollars(item.split('__')[2])} %
                                </Button>
                              </>
                            ) : (
                              <>
                                {' '}
                                <Button type="primary">
                                  CA$ {formatDollars(item.split('__')[2])}
                                </Button>
                              </>
                            )}
                          </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                          <Col
                            span={24}
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <span>{item.split('__')[0]}</span>
                          </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                          <Col
                            span={3}
                            style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                          >
                            <Button type="primary" style={{ borderRadius: '50%' }} ghost></Button>
                          </Col>
                          <Col
                            span={18}
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <div
                              style={{ width: '100%', height: '1px', backgroundColor: 'blue' }}
                            ></div>
                          </Col>
                          <Col
                            span={3}
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              alignItems: 'center',
                            }}
                          >
                            <Button type="primary" style={{ borderRadius: '50%' }} ghost></Button>
                          </Col>
                        </Row>
                        <Row style={{ width: '100%' }}>
                          <Col
                            span={24}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {updated[item]?.map((item, index) => {
                              return (
                                <p key={index}>
                                  <CheckCircleTwoTone
                                    twoToneColor="#1890ff"
                                    style={{ marginRight: '5px' }}
                                  />
                                  {item?.sub_category?.name?.length > 30
                                    ? item?.sub_category?.name?.slice(0, 30) + '...'
                                    : item?.sub_category?.name || 'Sub Category'}
                                </p>
                              );
                            })}
                          </Col>
                        </Row>
                      </>
                    </>
                  );
                })}
            </div>
            {
              <Row>
                <Col
                  span={24}
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <Button
                    type="link"
                    className="view-more-btn"
                    onClick={() => setExpanded(!expanded)}
                  >
                    {hasOverflow && (expanded ? 'Show Less' : 'View More')}
                  </Button>
                </Col>
              </Row>
            }
          </Card>
        </div>
      </Col>
    </>
  );
};

export default JobFeeCard;
